import { type FunctionalComponent, h } from '@stencil/core';
import { upperCaseFirstLetter } from '../../../../conversational-search-logic/utils/utils';
import { answerViewTypes, ctaSuggestionsEventDispatcher, eventDispatcherForFunctionalComponents } from '../../../../conversational-search-logic/utils/utils';
import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';
import { buildCommStatusQdsTagProps } from '../../../../../../../utils/helpers/map-comm-key-to-qds-tag';

export interface IConversationalSearchMessagesSuggestionsCard {
  data, // Allowing multiple different types to be used
  query: string;
  labelProvider: labelProviderInterface;
  index: number
  isObsoleteProductStatusVisible?: string;
  isBannerVariant?: boolean;
  isMultipleSuggestions?: boolean;
  hasSingleCommStatusKey?: boolean;
  language: string;
}

export const ConversationalSearchMessagesSuggestionsCard: FunctionalComponent<
  IConversationalSearchMessagesSuggestionsCard
> = (props) => {
    const isCommStatusVisible = props.data?.commStatus?.key && props.data?.commStatus?.key !== 'COMMERCIALIZED';
    const qdsTagParams = isCommStatusVisible ? buildCommStatusQdsTagProps(props.data?.commStatus.key) : undefined;
    const isBannerCardWithCommStatusNeighbour = props.isBannerVariant && !isCommStatusVisible && props.hasSingleCommStatusKey;

    const suggestionsEvents = (e: Event) => {
        const eventCategory = props?.isBannerVariant ? 'Product From Banner' : 'Product';
        eventDispatcherForFunctionalComponents('conversational-search:ga-suggestion-select', { index: props.index, suggestion: props.data});
        ctaSuggestionsEventDispatcher(e.type, props.data?.title, eventCategory, props.data?.url, props.query, props.index);
    };

    const hierarchyEvents = (e: Event) => {
        const bannerEventSuffix = props.isBannerVariant ? ' From Banner' : '';
        const categoryEventPrefix = props.data?.categoryL2 ? `${props.data.categoryL2} ` : '';
        const eventCategory = `${categoryEventPrefix}Hierarchy${bannerEventSuffix}`;
        ctaSuggestionsEventDispatcher(e.type, props.data?.title, eventCategory, props.data?.url, props.query, props.index);
    };

    const onClickAction = (e: Event) => props.data?.type === answerViewTypes.SuggestionResults ? suggestionsEvents(e) : hierarchyEvents(e);
    const imageAltText = props.labelProvider(
      'conversational.search.product.image',
      'Product image',
    );

    return (
      <article>
        <a
          class={{
            'conversational-search-messages-suggestions-card': true,
            'conversational-search-messages-suggestions-card--banner-variant': props.isBannerVariant
          }}
          href={props.data?.openUrl}
          tabindex={0}
          target="_blank"
          onClick={(e) => onClickAction(e)}
          onContextMenu={(e) => onClickAction(e)}
        >
          <section class="conversational-search-messages-suggestions-card-content">
            <uiaas-thumbnail
              src={props.data?.thumbnailUrl}
              alt={imageAltText}
              size='dynamic'
            />
            <section class={{
              'conversational-search-messages-suggestions-card-content-information': true,
              'conversational-search-messages-suggestions-card-content-information--long-text-lang': props.language === 'de'
            }}>
              {isCommStatusVisible || isBannerCardWithCommStatusNeighbour ?
                <div class='conversational-search-messages-suggestions-card-content-information__comm-status'>
                  <qds-tag
                    size="small"
                    icon-name="information-circle"
                    color={qdsTagParams?.color}
                    status={qdsTagParams?.status}
                    text={upperCaseFirstLetter(props.data?.commStatus?.translation)}
                  />
                </div> : ''}
              <strong class="conversational-search-messages-suggestions-card-content-information__title">{props.data?.title}</strong>
              <span class="conversational-search-messages-suggestions-card-content-information__subtitle">{props.data?.productId ?? props.data?.categoryL2Translation}</span>
            </section>
          </section>
        </a>
      </article>
    );
};
